import {
  RecipeCategoriesResponseModel,
  RecipeCategoryResponseModel,
  RecipeDetailResponseModel,
  BookmarkResponseModel,
  BookmarkedRecipesResponseModel,
  SearchRecipesResponseModel,
} from './../../../core/model/api-response/recipe-response-model';
import { UserDataService } from './../user-repository/user-data.service';
import { Injectable } from '@angular/core';
import { GenericResponse, GenericResponseData } from '../generic-response';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { baseUrl } from 'src/app/global-variables';
import { UserRefreshTokenService } from '../user-repository/user-refresh-token.service';

@Injectable({
  providedIn: 'root',
})
export class RecipeApiService {
  constructor(
    private http: HttpClient,
    private userDataService: UserDataService,
    private userRefreshTokenService: UserRefreshTokenService
  ) {}

  getRecipeCategories(): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<RecipeCategoriesResponseModel>(baseUrl + 'api/v2/recipe/list', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((result) => {
        if (result.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({ recipeCategories: result.categories })
          );
        } else {
          return new GenericResponse(false);
        }
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getRecipeCategories();
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }

  getRecipeCategory(
    categoryId: string,
    page: number,
    limit: number
  ): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<RecipeCategoryResponseModel>(
        baseUrl +
          'api/v2/recipe/category/' +
          categoryId +
          '?page=' +
          page +
          '&limit=' +
          limit,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((result) => {
        if (result.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({ recipeCategoryResponse: result })
          );
        } else {
          return new GenericResponse(false);
        }
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getRecipeCategory(categoryId, page, limit);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }

  searchRecipes(
    text: string,
    categoryId: string,
    page: number,
    limit: number
  ): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    let apiUrl =
      'api/v2/recipe/search?text=' + text + '&page=' + page + '&limit=' + limit;
    if (categoryId) {
      apiUrl =
        'api/v2/recipe/search?catId=' +
        categoryId +
        '&text=' +
        text +
        '&page=' +
        page +
        '&limit=' +
        limit;
    }
    return this.http
      .get<SearchRecipesResponseModel>(baseUrl + apiUrl, {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((result) => {
        if (result.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({ recipeCategoryResponse: result })
          );
        } else {
          return new GenericResponse(false);
        }
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.searchRecipes(text, categoryId, page, limit);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }

  getRecipeDetail(
    recipeId: string,
    storyBook: boolean = false
  ): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<RecipeDetailResponseModel>(
        baseUrl + 'api/v2/recipe/getById/' + recipeId,
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((result) => {
        if (result.success) {
          if (storyBook) {
            return new GenericResponse(
              true,
              new GenericResponseData({ cookingStoryRes: result })
            );
          } else {
            return new GenericResponse(
              true,
              new GenericResponseData({ recipeDetail: result.recipe })
            );
          }
        } else {
          return new GenericResponse(false);
        }
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getRecipeDetail(recipeId);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }

  bookmark(recipeId: string): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .post<BookmarkResponseModel>(
        baseUrl + 'api/v2/bookmark',
        {
          recipeId,
        },
        {
          headers: new HttpHeaders(headerDict),
        }
      )
      .toPromise()
      .then((result) => {
        if (result.success) {
          return new GenericResponse(true);
        } else {
          return new GenericResponse(false);
        }
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.bookmark(recipeId);
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }

  getBookmarkedRecipes(): Promise<GenericResponse> {
    const headerDict = this.userDataService.getHeaderDict();
    return this.http
      .get<BookmarkedRecipesResponseModel>(baseUrl + 'api/v2/bookmark', {
        headers: new HttpHeaders(headerDict),
      })
      .toPromise()
      .then((result) => {
        if (result.success) {
          return new GenericResponse(
            true,
            new GenericResponseData({ bookmarks: result.bookmarks })
          );
        } else {
          return new GenericResponse(false);
        }
      })
      .catch((e) => {
        console.log(e.status, e);
        if (e.status === 403 || e.status === 401) {
          this.userRefreshTokenService.refreshToken().then((resp) => {
            if (resp.isSuccess()) {
              this.getBookmarkedRecipes();
            }
          });
        }
        return new GenericResponse(
          false,
          new GenericResponseData({ message: 'خطای اتصال' })
        );
      });
  }
}
